import React from 'react'

const BookingsIndex = () => {
    return (
        <div>
            <h1>Bookings</h1>
        </div>
    )
}

export default BookingsIndex
